import { styled } from "goober";
import { Icon, type IconName } from "../Icon";
import { RefreshSpin } from "../RefreshSpin";
import { Text } from "../Text";
import type { ButtonStyle } from "./buttonStyle";

const IconWrap = styled("span")`
  display: inline-flex;
`;

export function ButtonContent({
  size = "m",
  icon,
  iconSpinning,
  iconTurnKey,
  spinningIcon,
  children,
}: Pick<ButtonStyle, "size" | "icon" | "children"> & {
  iconSpinning?: boolean;
  iconTurnKey?: number;
  spinningIcon?: IconName;
}) {
  return (
    <>
      {icon && (
        <IconWrap>
          {iconSpinning === undefined && iconTurnKey === undefined ? (
            <Icon name={icon} size={size === "l" ? 16 : 12} />
          ) : (
            <RefreshSpin
              spinning={iconSpinning ?? false}
              turnKey={iconTurnKey}
              resting={
                spinningIcon ? (
                  <Icon name={icon} size={size === "l" ? 16 : 12} />
                ) : undefined
              }
            >
              <Icon name={spinningIcon ?? icon} size={size === "l" ? 16 : 12} />
            </RefreshSpin>
          )}
        </IconWrap>
      )}
      {children && (
        <Text variant={size === "l" ? "text-regular-md" : "text-small-md"}>
          {children}
        </Text>
      )}
    </>
  );
}
